import React, {useState, useEffect, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import TopNavbar from '../../components/TopNavbar/TopNavbar';
import { useHistory } from 'react-router-dom';

import CourseTheatreFlow from "../../flows/CourseTheatreRecipe";
import {Link} from 'react-router-dom';
import AnimalsThumbnail from '../../components/AnimalsThumbnail/AnimalsThumbnail';
import {apiListRelationships} from '../../graphql/queries';
import gql from 'graphql-tag';
import {useQuery} from 'react-apollo';
// import catbearsAngry from './catbears_angry.png';
// import catbearsAngry2x from './catbears_angry@2x.png';
import FeedbackModal from '../../components/FeedbackModal/FeedbackModal';
import SubscriptionModal from "../../components/SubscriptionModal/SubscriptionModal";
import HeroPoster from 'components/HeroPoster/HeroPoster';
import {GlobalContext} from 'context/GlobalContext';
import './FELT-APP.scss';
import { track } from '../../utils/mixpanel';

function FeltHomePage({authContext}) {
  const {t} = useTranslation();
  const history = useHistory();
  // Let i18n.js manage body lang/dir consistently
  // history.push('/theatre');
  

    
    {/* <TopNavbar
        showNavBG={false}
        showLogo={false}
        authContext={authContext}
        user={authContext.user}
        // title={t(`course.title`)}
        border={false}
        // showMenuButton
        ></TopNavbar> */}

    {/* <div className="homepage texture"> */}
      {/* {!authContext.user.isOnboardingComplete && 
        <OnboardingCatbears authContext={authContext}/>
      } */}
    {/* Course start */}
      {/* {authContext.user.isOnboardingComplete && <div>Show Course Beginning</div>} */}
          {/* </div> */}

  

  //     {history.push('/theatre');}


  // courses gallery -- start --
  // ADD THIS TO THE TopNavbar
  // title={t(`course.title`)}


  {/* <div className="homepage texture">
      <div className="homepage-content ">
            <CoursesGallery />
        </div>
  </div> */}
// courses gallery -- end --



  const {loading, error, data: relationshipsData, refetch} = useQuery(gql(apiListRelationships));
  const CourseData = CourseTheatreFlow;
  const [relationships, setRelationships] = useState([]);
  const [isFeedbackModalState, setIsFeedbackModalState] = useState(false);
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
  const {VolumeSwitchState, setVolumeSwitchState} = useContext(GlobalContext);

  // const {t} = useTranslation();

  function getSessionStorageOrDefault(key, defaultValue) {
    const stored = sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);
  }

  useEffect(() => {
    if (relationshipsData) {
      setRelationships(relationshipsData.listRelationships.relationships);
    }

  }, [relationshipsData, isFeedbackModalState]);

  useEffect(() => {
    if(!authContext.user.isOnboardingComplete){
      console.log("start onboarding!")
    }
    refetch();
  }, [authContext.user.id])
  const addRelationshipDisabled = false; // REMOVING PAYWALL 7.10.2023
  console.log ("authContext!! , " , authContext)
  // Structured data for SEO
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Felt by The Catbears",
    "description": "Turn your conflicts into collaborations. A relationship tool that helps strengthen connections.",
    "applicationCategory": "LifestyleApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD",
      "availability": "https://schema.org/InStock",
      "priceSpecification": {
        "@type": "UnitPriceSpecification",
        "price": "0",
        "priceCurrency": "USD",
        "unitText": "Free to start"
      }
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.6",
      "ratingCount": "1"
    }
  };

  return (

    <>
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
    <TopNavbar
        showNavBG={true}
        showLogo={false}
        authContext={authContext}
        user={authContext.user}
        title={t(`topnavbar.menu.felt`)}
        isFelt
        // BackLinkTo={'/'}
        backgroundColor={"var(--color-skyblue)"}
        // border={true}
        opacity={'0.93'}
        texture={true}
        showMenuButton
        showLangButton
        VolumeSwitchState = {VolumeSwitchState} 
        setVolumeSwitchState = {setVolumeSwitchState}
        // showFeedbackModalButton
        // openFeedbackPopup={openFeedbackPopup}
      ></TopNavbar>

    <div className="FELT-container noselect">
      <div className="FELT-container--panel">
          
          {/* welcome message */}
            <div className="FELT-welcome-message">
              <div className="FELT-welcome-image">
                <img src={"/assets/catbears/jordy-say-hi.png"} alt="catbears happy together" />
              </div>
              <div className="FELT-welcome-text">
                <div className="FELT-welcome-title">{t(`homepage.main-question`)}</div>
                <div className="FELT-welcome-subtitle">{t('homepage.explainTerm')}</div>
              </div>
            </div>
          
        <div className="FELT-buttons">
          <div className="FELT-button-container">

          <div className="FELT-button" onClick={() => {
              try { track('APP_Felt_NewRelationship_Click'); } catch {}
              history.push(`/relationship/new`);
            }}>
              <img src={"/assets/icons/icon_plus.svg"} alt="plus icon" />
              </div>
            <p className="felt-thumbnail-text">{t(`homepage.addRelationship`)}</p>
          </div>
          {relationships.map((relationship, index) => {
            return (
              <div className="FELT-button-container" key={index} onClick={() => {
                history.push(`/relationship/${relationship.id}`);
              }}>
                <AnimalsThumbnail
                  animalId={relationship.animalId}
                  partnerAnimalId={relationship.partnerAnimalId}
                  wideThumbnail={true}
                  hoverScale={true}
                ></AnimalsThumbnail>
                <p className="felt-thumbnail-text">{t(`homepage.meAndPartner`, {
                  name: relationship.name,
                  partnerName: relationship.partnerName
                })}</p>
              </div>
            )
          })}
            <div className="FELT-button-container">
              <div className="FELT-button FELT-button--placeholder" onClick={() => {
                history.push(`/relationship/new`);
              }}></div>
              <p className="felt-thumbnail-text"></p>
            </div>
        </div>
      </div>
      <div className="FELT-container--footer">
        {/* <img src={"assets/catbears/catbears_felt_fight.svg"} alt="catbears mad at each other" />
        <img className="FELT-arrow" src={"assets/icons/icon_arrow-forward.svg"} alt="arrow" /> */}
        <img src={"/assets/catbears/catbears_felt_together.svg"} alt="catbears happy together" />
        {/* <h1>footer</h1> */}
      </div>
    </div>
    </>
    
    
    
    // <>
    //   <FeedbackModal
    //     isFeedbackModalState={isFeedbackModalState}
    //     setIsFeedbackModalState={setIsFeedbackModalState}
    //   />

    //   {/* <Onboarding relationships={relationships} authContext={authContext}/> */}

    //   <SubscriptionModal isOpen={isSubscriptionModalOpen}
    //                      onExit={() => setIsSubscriptionModalOpen(false)}
    //   />
    //   {/* <TopNavbar
    //     showNavBG={false}
    //     showLogo={false}
    //     authContext={authContext}
    //     user={authContext.user}
    //     border={false}
    //   ></TopNavbar> */}
    //   <div className="homepage pageLeftRightPadding noselect">
    //     <div className="homepage-content">
    //       <div className="homepage-content--bottom texture">
    //         <div className="felt--container">
    //           <div className="felt--container--side-a">
    //             <div className="felt--container--text">
    //               <h1 className="homepage__main-question noselect">{t(`homepage.main-question`)}</h1>
    //               <p className=" noselect">{t('homepage.explainTerm')}</p>
    //             </div>
    //             <ul className="felt__list noselect">
    //               {relationships.map((relationship, index) => {
    //                 return (
    //                   <Link
    //                     key={index}
    //                     to={{
    //                       pathname: `/relationship/${relationship.id}`,
    //                       state: {relationship}
    //                     }}
    //                   >
    //                     <li className="felt__list-item">
    //                       <AnimalsThumbnail
    //                         animalId={relationship.animalId}
    //                         partnerAnimalId={relationship.partnerAnimalId}
    //                       ></AnimalsThumbnail>
    //                       <p>
    //                         {t(`homepage.meAndPartner`, {
    //                           name: relationship.name,
    //                           partnerName: relationship.partnerName
    //                         })}
    //                       </p>
    //                     </li>
    //                   </Link>
    //                 );
    //               })}
    //               <Link className="add-button" to={!addRelationshipDisabled ? `/relationship/new` : ''}>
    //                 <li className="felt__list-item--create">
    //                   <button
    //                     onClick={addRelationshipDisabled ? () => {
    //                       setIsSubscriptionModalOpen(true)
    //                     } : null}>{`+`}</button>
    //                   <p>{t(`homepage.addRelationship`)}</p>
    //                 </li>
    //               </Link>
    //               {console.log("relationships", relationships)}
    //                 <Link to={!addRelationshipDisabled ? `/relationship/new` : ''}>
    //                   <li className="felt__list-item felt__list-item--placeholder--container" onClick={addRelationshipDisabled ? () => {
    //                       setIsSubscriptionModalOpen(true) 
    //                     } : null}>
    //                     <div className="felt__list-item--placeholder"></div>
    //                   </li>                
    //                   </Link>
    //             </ul>
    //           </div>
    //           <div className="felt--container--side-b">
    //             {/* <img
    //                   alt={`catbearsAngry`}
    //                   src={catbearsAngry}
    //                   srcSet={`${catbearsAngry2x} 2x, ${catbearsAngry2x} 3x`}
    //                   className="catbearsAngry"
    //                   /> */}
    //           </div>
    //         </div>
    //       </div>
    //       </div>
    //     </div>
    // </>
  );
}

export default FeltHomePage;
